
import React from 'react';
import SecondarySchool from 'views/SecondarySchool'

const SecondarySchoolpage = () => {
  return <SecondarySchool/>;
};

export default SecondarySchoolpage;